import { Group, Text, Title } from "@mantine/core";

interface PageHeaderProps {
	title: string;
	description: string;
	actions?: React.ReactNode;
}

function PageHeader({ title, description, actions }: PageHeaderProps) {
	return (
		<Group
			justify="space-between"
			mb="lg">
			<div>
				<Title order={2}>{title}</Title>
				<Text c="dimmed">{description}</Text>
			</div>
			{actions}
		</Group>
	);
}

export default PageHeader;
